export class Products {
  Id : string='';
  Vendor : string='';
  PartNo : string='';
  Eccn : string='';
  HsCode : string='';
  TaraOrigine : string='';
  GreutateNeta : number=0.0;
  CategorieTimbruVerde : string='';
}
